export const server_debug = 'https://yn.dev-fusiocraft.com'
export const server_product = ''